import Reflux from 'reflux';

export default Reflux.createActions([
  'createSuccess',
  'update',
  'updateError',
  'updateSuccess',
  'loadStats',
  'loadStatsError',
  'loadStatsSuccess',
  'loadStatsForProjectSuccess',
  'removeProject',
  'removeProjectError',
  'removeProjectSuccess',
  'setActive',
  'changeSlug',
  'addTeam',
  'addTeamSuccess',
  'addTeamError',
  'removeTeam',
  'removeTeamSuccess',
  'removeTeamError',
]);



// WEBPACK FOOTER //
// ./app/actions/projectActions.jsx